import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { RefreshCw, Loader2 } from "lucide-react";

interface RequestMentorshipAgainDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  isPending: boolean;
  otherPersonName: string;
}

export function RequestMentorshipAgainDialog({
  open,
  onOpenChange,
  onConfirm,
  isPending,
  otherPersonName,
}: RequestMentorshipAgainDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="sm:max-w-md">
        <AlertDialogHeader className="text-center sm:text-center">
          <div className="mx-auto mb-2 flex h-12 w-12 items-center justify-center rounded-full bg-primary/10">
            <RefreshCw className="h-6 w-6 text-primary" />
          </div>
          <AlertDialogTitle className="text-xl">
            Ready for another cycle?
          </AlertDialogTitle>
          <AlertDialogDescription className="text-base space-y-3 pt-2">
            <p>
              Mentorships work best when they're intentional.
            </p>
            <p>
              Are you ready to start another focused mentorship cycle with {otherPersonName}?
            </p>
            <p className="text-sm text-muted-foreground italic">
              When you're ready for your next focused push.
            </p>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="flex-col sm:flex-row gap-2 mt-4">
          <AlertDialogCancel disabled={isPending}>
            Cancel
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={(e) => {
              e.preventDefault();
              onConfirm();
            }}
            disabled={isPending}
          >
            {isPending ? (
              <Loader2 className="h-4 w-4 animate-spin mr-2" />
            ) : (
              <RefreshCw className="h-4 w-4 mr-2" />
            )}
            Request Mentorship
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
